import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, Subject, timeout } from 'rxjs';

@Component({
  selector: 'app-yes-no',
  imports: [],
  templateUrl: './yes-no.component.html',
  styleUrl: './yes-no.component.scss'
})
export class YesNoDialogComponent {
  @Input()
  id!: string

  private answer: Subject<boolean> = new Subject(); 

  public getAnswer() : Observable<boolean> {
    return this.answer.asObservable().pipe(timeout(10000));
  }

  emitYes() : void {
    this.answer.next(true);
    this.answer.complete();
  }

  emitNo() : void {
    this.answer.next(false);
    this.answer.complete();
  }
}
